import styled from 'styled-components';

import { BodyM } from '@sorare/core/src/atoms/typography';

export const SectionTitle = styled(BodyM)`
  font-weight: var(--t-bold);
`;
